var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component enaqPiediagramm"},[_c('apexchart',{attrs:{"width":"90%","height":'90%',"type":"pie","options":_vm.graphOptions,"series":_vm.graphData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }